import type { Result } from '@rental/contracts/client'
import { useState } from 'react'
import { useAccess } from '../access-context'
import type { StaffProblem } from '../problems'

/**
 * One change to a fine, sent once: busy while it goes, the API's problem
 * kept for the screen, a session taken over handled by the shell. The
 * answer's data comes back for the screen to show the fine as it now stands.
 */
export function useSend() {
  const { takeOver } = useAccess()
  const [busy, setBusy] = useState(false)
  const [problem, setProblem] = useState<StaffProblem | null>(null)
  async function send<T>(request: () => Promise<Result<T>>): Promise<T | null> {
    setProblem(null)
    setBusy(true)
    const result = await request()
    setBusy(false)
    if (result.ok) return result.data
    if (!takeOver(result.problem)) setProblem(result.problem)
    return null
  }
  return { send, busy, problem, clear: () => setProblem(null) }
}
